import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { API, pesanGalat } from "../lib/api";

const KATEGORI = ["perangkat rusak", "jaringan", "printer", "aplikasi error", "reset kata sandi", "lain-lain"];

export default function Minta() {
  const { kode } = useParams();
  const [jenis, setJenis] = useState("akses");
  const [ptList, setPtList] = useState([]);
  const [pt, setPt] = useState(kode || "");
  const [sistem, setSistem] = useState([]);
  const [orang, setOrang] = useState([]);
  const [f, setF] = useState({ orang_id: "", sistem_id: "", arah: "BUKA", hak: "", alasan: "", diminta_oleh: "" });
  const [l, setL] = useState({ kategori: "perangkat rusak", nama_pemohon: "", kebutuhan_singkat: "" });
  const [hasil, setHasil] = useState(null);
  const [galat, setGalat] = useState(null);
  const [muat, setMuat] = useState(false);

  useEffect(() => {
    API.get("/publik/perusahaan").then((r) => {
      setPtList(r.data);
      if (r.data.length) {
        setPt((nilaiSekarang) => nilaiSekarang || kode || r.data[0].kode);
      }
    }).catch(() => {});
  }, [kode]);

  useEffect(() => {
    if (!pt) return;
    const p = `?perusahaan=${encodeURIComponent(pt)}`;
    setF((x) => ({ ...x, orang_id: "", sistem_id: "" }));
    API.get(`/publik/sistem${p}`).then((r) => setSistem(r.data)).catch(() => setSistem([]));
    API.get(`/publik/orang${p}`).then((r) => setOrang(r.data)).catch(() => setOrang([]));
  }, [pt]);

  const kirimAkses = async (e) => {
    e.preventDefault();
    setMuat(true); setGalat(null);
    try {
      const r = await API.post("/perubahan", { ...f, mode: "langsung", perusahaan_id: pt });
      setHasil({ jenis: "akses", nomor: r.data.nomor });
    } catch (err) { setGalat(pesanGalat(err)); } finally { setMuat(false); }
  };
  const kirimLain = async (e) => {
    e.preventDefault();
    setMuat(true); setGalat(null);
    try {
      const r = await API.post("/lain-lain", { ...l, perusahaan_id: pt });
      setHasil({ jenis: "lain", arahan: r.data.arahan });
    } catch (err) { setGalat(pesanGalat(err)); } finally { setMuat(false); }
  };

  const kelasInput = "mt-1.5 w-full border rounded px-3 py-2.5 text-sm";

  return (
    <div className="min-h-screen flex flex-col">
      <header className="kaca border-b sticky top-0 z-20">
        <div className="max-w-[1000px] mx-auto px-4 md:px-8 h-14 flex items-center justify-between">
          <Link to="/" data-testid="tautan-beranda" className="flex items-center gap-2">
            <ShieldCheck size={18} className="text-primary" aria-hidden="true" />
            <span className="font-heading font-bold text-lg">PAM-IT</span>
          </Link>
          <Link to="/verifikasi" className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-150">
            Cek surat
          </Link>
        </div>
      </header>

      <main className="flex-1 px-4 py-14 max-w-xl w-full mx-auto">
        <p className="label-kecil">Formulir terbuka</p>
        <h1 className="mt-4 text-4xl font-bold" data-testid="judul-minta">Catat perubahan akses</h1>
        <p className="mt-3 text-sm text-muted-foreground leading-relaxed">
          Tidak perlu punya akun. Pilih perusahaannya, lalu pilih orang dan aksesnya, dan tentukan mau dibuka atau ditutup.
          Catatan ini langsung masuk buku dan diteruskan ke pemilik akses.
        </p>

        <div className="mt-6">
          <label htmlFor="m-pt" className="label-kecil">Perusahaan</label>
          <select id="m-pt" data-testid="pilih-perusahaan" value={pt} onChange={(e) => setPt(e.target.value)}
            className="mt-1.5 w-full border rounded px-3 py-2.5 text-sm">
            {ptList.map((p) => (
              <option key={p.id} value={p.kode}>{p.nama}{p.contoh ? " (data contoh)" : ""}</option>
            ))}
          </select>
          <p className="mt-2 text-xs text-muted-foreground leading-relaxed" data-testid="catatan-formulir-minta">
            Yang muncul di daftar ini hanya perusahaan yang sengaja membuka formulir umum, ditambah data contoh.
            Kalau perusahaan Anda belum ada, mintalah tautan formulirnya ke tim IT mereka.
          </p>
        </div>

        {hasil ? (
          <div className="panel rounded mt-8 p-6" data-testid="konfirmasi-minta">
            {hasil.jenis === "akses" ? (
              <>
                <p className="text-sm text-muted-foreground">Sudah tercatat. Ini nomor catatan Anda:</p>
                <p className="font-data text-3xl font-bold mt-3 text-primary" data-testid="nomor-hasil">{hasil.nomor}</p>
                <p className="mt-4 text-sm text-muted-foreground">
                  Simpan nomornya. Pemilik akses akan menutup atau membuka aksesnya, lalu menulis buktinya.
                </p>
              </>
            ) : (
              <>
                <p className="text-sm" data-testid="konfirmasi-lain">
                  Catatan Anda sudah masuk Buku Lain-lain, lengkap dengan waktu dari server.
                </p>
                {hasil.arahan && (
                  <p className="mt-4 rounded border border-accent/50 bg-accent/10 p-3 text-sm" data-testid="arahan-sandi">
                    {hasil.arahan}
                  </p>
                )}
              </>
            )}
            <button data-testid="btn-minta-lagi" onClick={() => { setHasil(null); setGalat(null); }}
              className="tombol-garis mt-6 px-4 py-2 rounded text-sm">
              Catat yang lain
            </button>
          </div>
        ) : jenis === "akses" ? (
          <form onSubmit={kirimAkses} className="mt-8 space-y-5" data-testid="form-minta-akses">
            <div>
              <label htmlFor="m-nama" className="label-kecil">Nama Anda</label>
              <input id="m-nama" data-testid="input-nama-pemohon" required value={f.diminta_oleh}
                onChange={(e) => setF({ ...f, diminta_oleh: e.target.value })} className={kelasInput} />
            </div>
            <div>
              <label htmlFor="m-orang" className="label-kecil">Aksesnya milik siapa</label>
              <select id="m-orang" data-testid="pilih-orang-minta" required value={f.orang_id}
                onChange={(e) => setF({ ...f, orang_id: e.target.value })} className={kelasInput}>
                <option value="">— pilih nama —</option>
                {orang.map((o) => <option key={o.id} value={o.id}>{`${o.kode} — ${o.nama_tampil}`}</option>)}
              </select>
            </div>
            <div>
              <label htmlFor="m-sistem" className="label-kecil">Akses mana</label>
              <select id="m-sistem" data-testid="pilih-sistem-minta" required value={f.sistem_id}
                onChange={(e) => setF({ ...f, sistem_id: e.target.value })} className={kelasInput}>
                <option value="">— pilih akses —</option>
                {sistem.map((s) => <option key={s.id} value={s.id}>{s.label}</option>)}
              </select>
            </div>
            <fieldset>
              <legend className="label-kecil">Mau diapakan</legend>
              <div className="mt-1.5 grid grid-cols-2 gap-2">
                {[["BUKA", "Buka akses"], ["TUTUP", "Tutup akses"]].map(([a, teks]) => (
                  <label key={a} data-testid={`pilih-arah-${a.toLowerCase()}`}
                    className={`rounded border px-3 py-2.5 text-sm text-center cursor-pointer transition-colors duration-150 ${f.arah === a ? "bg-primary text-primary-foreground border-primary font-semibold" : "hover:bg-secondary"}`}>
                    <input type="radio" name="arah" value={a} checked={f.arah === a} data-testid={`radio-${a.toLowerCase()}`}
                      onChange={() => setF({ ...f, arah: a })} className="sr-only" />
                    {teks}
                  </label>
                ))}
              </div>
            </fieldset>
            <div>
              <label htmlFor="m-hak" className="label-kecil">Haknya apa</label>
              <input id="m-hak" data-testid="input-hak-minta" required value={f.hak}
                onChange={(e) => setF({ ...f, hak: e.target.value })} placeholder="mis. baca, tulis, admin" className={kelasInput} />
            </div>
            <div>
              <label htmlFor="m-alasan" className="label-kecil">Alasannya (boleh dikosongkan)</label>
              <input id="m-alasan" data-testid="input-alasan-minta" value={f.alasan}
                onChange={(e) => setF({ ...f, alasan: e.target.value })} className={kelasInput} />
            </div>
            {galat && <p data-testid="galat-minta" className="text-sm text-destructive">{galat}</p>}
            <button data-testid="btn-kirim-minta" disabled={muat} className="tombol-utama w-full px-4 py-3 rounded text-sm disabled:opacity-50">
              {muat ? "Mencatat…" : "Catat sekarang"}
            </button>
            <p className="text-sm text-center">
              <button type="button" data-testid="tautan-bukan-akses" onClick={() => { setJenis("lain"); setGalat(null); }}
                className="underline text-muted-foreground hover:text-foreground transition-colors duration-150">
                Kebutuhan saya bukan soal akses
              </button>
            </p>
          </form>
        ) : (
          <form onSubmit={kirimLain} className="mt-8 space-y-5" data-testid="form-lain-lain">
            <div>
              <label htmlFor="l-kategori" className="label-kecil">Soal apa</label>
              <select id="l-kategori" data-testid="pilih-kategori-lain" value={l.kategori}
                onChange={(e) => setL({ ...l, kategori: e.target.value })} className={kelasInput}>
                {KATEGORI.map((k) => <option key={k} value={k}>{k}</option>)}
              </select>
              {l.kategori === "reset kata sandi" && (
                <p className="mt-2.5 rounded border border-accent/50 bg-accent/10 p-3 text-xs leading-relaxed" data-testid="peringatan-sandi">
                  Reset kata sandi tidak diurus di sini — hubungi langsung petugas IT di kantor Anda. Aplikasi ini tidak pernah
                  menyimpan, meminta, atau menampilkan kata sandi siapa pun.
                </p>
              )}
            </div>
            <div>
              <label htmlFor="l-nama" className="label-kecil">Nama Anda</label>
              <input id="l-nama" data-testid="input-nama-lain" required value={l.nama_pemohon}
                onChange={(e) => setL({ ...l, nama_pemohon: e.target.value })} className={kelasInput} />
            </div>
            <div>
              <label htmlFor="l-butuh" className="label-kecil">
                Kebutuhannya, satu kalimat saja <span className="font-data">({l.kebutuhan_singkat.length}/140)</span>
              </label>
              <input id="l-butuh" data-testid="input-kebutuhan-lain" required maxLength={140} value={l.kebutuhan_singkat}
                onChange={(e) => setL({ ...l, kebutuhan_singkat: e.target.value })} className={kelasInput} />
            </div>
            {galat && <p data-testid="galat-lain" className="text-sm text-destructive">{galat}</p>}
            <button data-testid="btn-kirim-lain" disabled={muat} className="tombol-utama w-full px-4 py-3 rounded text-sm disabled:opacity-50">
              {muat ? "Mencatat…" : "Catat ke Buku Lain-lain"}
            </button>
            <p className="text-sm text-center">
              <button type="button" data-testid="tautan-akses" onClick={() => { setJenis("akses"); setGalat(null); }}
                className="underline text-muted-foreground hover:text-foreground transition-colors duration-150">
                Kembali ke perubahan akses
              </button>
            </p>
          </form>
        )}
      </main>
    </div>
  );
}
